import React from 'react';
import { BookModel } from '../../../interfaces/book.interface';
import { UserModel } from '../../../interfaces/user.interface';

interface BookCopyrightProps {
  bookData: BookModel | null;
  user: UserModel | null;
  Logo: string;
}

const getCurrentYear = () => {
  return new Date().getFullYear();
};

const BookCopyright: React.FC<BookCopyrightProps> = ({ bookData, user, Logo }) => {
  return (
    <div
      className="h-[18rem] w-[18rem] md:w-[800px] md:h-[800px] flex flex-col justify-around rounded-lg mx-auto py-3 bg-gray-200"
      style={{
        backgroundImage: `url("/paper.jpg")`,
        backgroundSize: 'cover'
      }}
    >
      <div className="flex flex-col justify-center items-center p-6 md:p-16 gap-8 md:gap-12">
        <h3 className="text-lg md:text-4xl bold font-yuji-boku">{bookData?.title}</h3>
        <h3 className="text-[10px] md:text-2xl text-justify text-black">
          <p className="leading-[12px] md:leading-8 font-poppins mb-2 md:mb-8">
            All rights reserved. No part of the publication may be reproduced, stored in or
            introduced
            into a retrieval system, or transmitted, in any form, or by any means (electronic,
            mechanical,
            photocopying, recording or otherwise) without the prior written permission of the
            author.
          </p>
          <p className="leading-[12px] md:leading-8 font-poppins">
            Any person who does any unauthorized act in relation to this publication may be
            liable to
            criminal prosecution and civil claims for damages. Text and illustrations
            copyright &#169;{' '}
            {user?.firstName} {user?.lastName} {getCurrentYear()} Moral rights asserted.
          </p>
        </h3>
      </div>
      <div className="w-full flex flex-col items-center gap-1">
        <div className="flex items-baseline gap-1">
          <img className="h-3 md:h-6 w-auto" src={Logo} alt="Build My Story" />
        </div>
      </div>
    </div>
  );
};

export default BookCopyright;
